import menu from './menu.js';

export default (module_name, operations = [], reports = []) =>
`<div class="crud fsb fac">
	<ul class="menu submenu">
		<li hash="#insert" title="Inserir"><img src="img/insert.svg"><span>Inserir</span></li>
		<li hash="#filter" title="Filtrar"><img src="img/filter.svg"><span>Filtrar</span></li>
		<li title="Menu de Operações"><img src="img/operations.svg"><span>Operações</span>
			${menu(operations)}
		</li>
		<li title="Menu de Relatórios"><img src="img/reports.svg"><span>Imprimir</span>
			${menu(reports)}
		</li>
		<!--
		<li hash="#export" title="Exportar Registros"><img src="img/export.svg"><span>Exportar</span></li>
		<li hash="#import" title="Importar Registros"><img src="img/import.svg"><span>Importar</span></li>
		-->
		<li hash="#setup" title="Configurar Página"><img src="img/setup.svg"><span>Configurar</span></li>
		<li hash="#first" title="Primeira Página"><img src="img/first.svg"><span>Primeira</span></li>
		<li hash="#previous" title="Página Anterior"><img src="img/previous.svg"><span>Anterior</span></li>
		<li hash="#reload" title="Recarregar Página"><img src="img/reload.svg"><span>Atual</span></li>
		<li hash="#next" title="Próxima Página"><img src="img/next.svg"><span>Próxima</span></li>
		<li hash="#last" title="Última Página"><img src="img/last.svg"><span>Última</span></li>
	</ul>
	<span id="module_name">
		${module_name}
	</span>
	<span id="page_info">
		Página&nbsp;<span id="page">&hellip;</span>
	</span>
</div>
<div id="grid">
</div>`;

